module.exports = __webpack_public_path__ + "static/sport/bgi-pc.bb6028a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-pc.jpg
// module id = Ddo7
// module chunks = 0